// Breadcrumb tracker - tracks user navigation path for contextual breadcrumbs
(function() {
  'use strict';

  // Track the referring collection when navigating to product pages
  function trackReferrer() {
    const referrer = document.referrer;
    
    // Only track if coming from same domain
    if (!referrer || !referrer.includes(window.location.hostname)) {
      return;
    }

    // Extract collection handle from referrer URL
    const collectionMatch = referrer.match(/\/collections\/([^/?#]+)/);
    
    if (collectionMatch) {
      const collectionHandle = collectionMatch[1];
      
      // Store in sessionStorage so it persists during the session
      sessionStorage.setItem('breadcrumb_referrer_collection', collectionHandle);
      
      // Also store the full referrer URL for debugging
      sessionStorage.setItem('breadcrumb_referrer_url', referrer);
    }
  }

  // Add collection handle to product links when clicked
  function enhanceProductLinks() {
    // Only run on collection pages
    if (!window.location.pathname.includes('/collections/')) {
      return;
    }

    // Get current collection handle from URL
    const collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    if (!collectionMatch) return;
    
    const collectionHandle = collectionMatch[1];

    // Find all product links on the page
    const productLinks = document.querySelectorAll('a[href*="/products/"]');
    
    productLinks.forEach(link => {
      // Add click event to store collection in sessionStorage
      link.addEventListener('click', function(e) {
        sessionStorage.setItem('breadcrumb_referrer_collection', collectionHandle);
        sessionStorage.setItem('breadcrumb_referrer_url', window.location.href);
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackReferrer();
      enhanceProductLinks();
    });
  } else {
    trackReferrer();
    enhanceProductLinks();
  }

  // Re-run when using back/forward buttons
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      trackReferrer();
      enhanceProductLinks();
    }
  });
})();
